/**
 * Color manipulation utilities for statistics charts
 */

/**
 * Convert hex color to rgba format
 * @param hex - Hex color string (e.g., "#4285F4")
 * @param alpha - Alpha value (0-1), defaults to 1
 * @returns RGBA color string
 */
export function hexToRgba(hex: string, alpha = 1): string {
  // For predefined names like dataset labels, return a default color
  if (!hex.startsWith('#')) {
    return `rgba(66, 133, 244, ${alpha})`
  }

  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

/**
 * Convert hex color to RGB string (without alpha)
 * @param hex - Hex color string (e.g., "#4285F4")
 * @returns RGB string in format "r, g, b" (e.g., "66, 133, 244")
 */
export function hexToRgb(hex: string): string {
  if (!hex.startsWith('#')) {
    return '54, 162, 235'
  }
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return `${r}, ${g}, ${b}`
}

/**
 * Get color for consultation type
 * @param type - Consultation type key
 * @returns Hex color string
 */
export function getColorForType(type: string): string {
  const colors: Record<string, string> = {
    classic: '#4285F4', // Blue
    emergency: '#EA4335', // Red
    local: '#34A853', // Green
    meeting_only: '#FBBC05', // Yellow
    netsoins: '#8F44AD', // Purple
    pedcl: '#F39C12', // Orange
  }

  return colors[type] || '#4285F4'
}
